export class OtherOffer {
	bettingTypeId: string;
	isFavorite: boolean;
	count: number;
}